import { compose, lifecycle, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import {
  actions as ordersActions,
  selectors as ordersSelectors,
} from 'state/orders';
import FiltersBox from 'components/orders/Filters/Filters/Dates/FiltersBox/component';

const enhance = compose(
  withTranslation('Orders'),
  connect(
    (state) => ({
      pathname: state.router.location.pathname,
      firstPickupTime: ordersSelectors.getFilterFirstPickupTime(state),
      lastDropoffTime: ordersSelectors.getFilterLastDropoffTime(state),
    }),
    {
      clearDatesFilter: ordersActions.clearDatesFilter,
    }
  ),
  withHandlers(() => {
    let innerRef;
    return {
      registerChild: () => (ref) => {
        innerRef = ref;
      },
      click:
        ({ onClickOutside }) =>
        (e) => {
          if (
            !innerRef ||
            innerRef.contains(e.target) ||
            (e.path && e.path.indexOf(innerRef) >= 0)
          ) {
            return;
          }
          onClickOutside(e);
        },
      handleApply:
        ({ onClickOutside }) =>
        (e) => {
          onClickOutside(e);
        },
      handleQuit:
        ({ clearDatesFilter, pathname }) =>
        (e) => {
          e.preventDefault();
          e.stopPropagation();
          clearDatesFilter({ pathname });
        },
    };
  }),
  lifecycle({
    componentDidMount() {
      document.addEventListener('click', this.props.click, false);
    },
    componentWillUnmount() {
      document.removeEventListener('click', this.props.click, false);
    },
  })
);

export default enhance(FiltersBox);
